export const DATA_TEST_ID = `modal`
export const REFRESH_BUTTON_LABEL = 'Try Refresh'
export const BODY_TEXT =
  'Try refreshing, checking your internet connection, or log back in.'
export const HEADER_TEXT1 = 'Looks like there has been a problem. '
export const HEADER_TEXT2 = "We can't save right now."
